import { Phone, MapPin, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/data/site";

export const Contact = () => {
  return (
    <footer
      id="contacte"
      data-testid="contact-section"
      className="scroll-target relative grain-overlay bg-[#8B0000] text-[#FDFBF7] py-20 md:py-28"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#E9D7A8]">
              Contacte
            </span>
            <h2 className="font-display text-4xl sm:text-5xl font-semibold mt-4 leading-tight">
              Tens algun dubte o encàrrec?
            </h2>
            <p className="mt-5 text-[#FDFBF7]/80 text-lg leading-relaxed max-w-lg">
              Truca'ns o escriu-nos per WhatsApp i t'ajudarem amb tot el que
              necessitis.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                data-testid="contact-call-btn"
                href={`tel:${BUSINESS.phoneTel}`}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#FDFBF7] text-[#8B0000] px-8 py-4 font-semibold hover:-translate-y-1 hover:shadow-2xl transition-all"
              >
                <Phone size={18} /> {BUSINESS.phoneDisplay}
              </a>
              <a
                data-testid="contact-whatsapp-btn"
                href={BUSINESS.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-8 py-4 font-semibold hover:-translate-y-1 hover:shadow-2xl transition-all"
              >
                <MessageCircle size={18} /> WhatsApp
              </a>
            </div>
          </div>

          <div className="lg:justify-self-end">
            <div className="flex items-start gap-3 text-[#FDFBF7]/90">
              <MapPin className="text-[#E9D7A8] shrink-0 mt-1" size={22} />
              <div>
                <p className="font-display text-2xl font-semibold text-[#FDFBF7]">
                  {BUSINESS.name}
                </p>
                <p className="mt-2 max-w-xs">{BUSINESS.address}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FDFBF7]/20 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#FDFBF7]/70">
          <p>© {new Date().getFullYear()} {BUSINESS.name} · Calella, Barcelona</p>
          <p className="font-display italic text-[#E9D7A8]">Artesans des de 1965</p>
        </div>
      </div>
    </footer>
  );
};
